import React from 'react'
import { Box, Typography } from '@mui/material'

const ShoppingFAQs = () => {
  return (
    <Box sx={{
      mt: 10,
      px: {
        xs: 2,
        md: 5,
        lg: 5
      },
      mb: {
        xs: 0,
        md: 5,
        lg: 10
      }
    }}>

      <Typography variant='h4' sx={{ textAlign: "center", fontWeight: "bolder", mb: 3 }}>SHOPPING FAQS</Typography>
      <Box sx={{ backgroundColor: "#F7FBFF", py: 4, px: 3 }}>

        <Typography variant='body2' sx={{ mb: 2 }}>By placing an order with Amber, you agree to the following terms and conditions. Please read them carefully before making any purchases.</Typography>

        <Typography variant='body2' sx={{ fontWeight: "400", mb: 2 }}>1. General Information</Typography>

        <Typography variant='body2' sx={{ mb: 2 }}>1.1. These Terms and Conditions apply to all products sold by Amber, whether through our website, in-store, or via third-party platforms. <br/>1.2. Amber reserves the right to modify or update these terms at any time without prior notice. Changes will be effective immediately upon posting on our website.</Typography>

        <Typography variant='body2' sx={{ fontWeight: "400", mb: 2 }}>2. Pricing and Payment</Typography>

        <Typography variant='body2' sx={{ mb: 2 }}>2.1. All prices are listed in MYR and are subject to change without notice. Prices do not include taxes, shipping, or handling charges unless specified. <br/>2.2. Payment for orders must be made in full at the time of purchase. We accept the following payment methods: Credit cards, Debit cards, FPX, and PayPal. <br/>2.3. If a payment is declined or canceled, Amber reserves the right to cancel or delay the order.</Typography>

        <Typography variant='body2' sx={{ fontWeight: "400", mb: 2 }}>3. Orders and Shipping</Typography>

        <Typography variant='body2' sx={{ mb: 2 }}>3.1. All orders are subject to availability. If an item is out of stock, we will notify you and offer alternative products exchange. <br/>3.2. Shipping costs are calculated based on the delivery address and the size of the order. Estimated delivery times are provided at checkout. <br/>3.3. We will not be responsible for any delays caused by third-party carriers or unforeseen events (e.g., weather, strikes, etc.). <br/>3.4. You are responsible for providing accurate shipping information. Amber will not be liable for delivery issues arising from incorrect information provided by the customer. </Typography>

        <Typography variant='body2' sx={{ fontWeight: "400", mb: 2 }}>4. Returns and Refunds</Typography>

        <Typography variant='body2' sx={{ mb: 2 }}>4.1. If you are not satisfied with your purchase, you may return for an exchange. Exchange are permissible for new items only. No refund is allowed. <br/>4.2. Returned products must be in new, unused condition with all original packaging and tags. <br/>4.3.Customers are responsible for return shipping costs unless the return is due to an error on our part (e.g., incorrect or damaged items).</Typography>

        <Typography variant='body2' sx={{ fontWeight: "400", mb: 2 }}>5. Damaged or Defective Products</Typography>

        <Typography variant='body2' sx={{ mb: 2 }}>5.1. If your item arrives damaged or defective, please contact us within 7 days of receipt for an exchange. <br/>5.2. We may require photographic evidence of the damaged product before proceeding with the return.</Typography>

        <Typography variant='body2' sx={{ fontWeight: "400", mb: 2 }}>6. Privacy and Data Protection</Typography>

        <Typography variant='body2' sx={{ mb: 2 }}>6.1. We are committed to protecting your privacy. For information on how we collect, use, and store your personal data, please refer to our [Privacy Policy].</Typography>

        <Typography variant='body2' sx={{ fontWeight: "400", mb: 2 }}> 7. Limitation of Liability</Typography>

        <Typography variant='body2' sx={{ mb: 2 }}> 7.1. Amber will not be liable for any direct, indirect, incidental, or consequential damages arising from the use or inability to use our products, including but not limited to lost profits, loss of data, or business interruption.</Typography>

        <Typography variant='body2' sx={{ fontWeight: "400", mb: 2 }}>8. Governing Law</Typography>

        <Typography variant='body2' sx={{ mb: 2 }}>8.1. These Terms and Conditions shall be governed by and construed in accordance with the laws of Malaysia without regard to its conflict of law principles.</Typography>

        <Typography variant='body2' sx={{ fontWeight: "400", mb: 2 }}>9. Contact Information</Typography>

        <Typography variant='body2' sx={{ mb: 2 }}>9.1. For any questions regarding these terms or to contact us about your order, please reach out to us at: <br/>AMBER Email: admin@amberofficials.com.my <br/>Phone: +60 17228 2072 <br/>Website: https://amberofficials.com.my</Typography>

      </Box>
    </Box>
  )
}

export default ShoppingFAQs